import React from 'react';

export const Text = props => {
	const { children, className } = props;
	return <p className={`text ${className || ""}`}>{children}</p>;
};


// WEBPACK FOOTER //
// src/atoms/lib/Text.js